<template>
  <div class="adobe-bestseller adobe-target-reco-elements">
    <fn-headline type="h2">
      {{ headline }}
      <fn-tag
        v-if="counterTime && timeLeft"
        countdown
      >
        {{ timeLeft }}
      </fn-tag>
    </fn-headline>
    <fn-product-teaser
      :product="product"
      :reco-name="reco_name"
      :reco-audience="reco_audience"
      :free-text="freeText"
      bestseller
    />
  </div>
</template>

<script>
export default defineComponent({
  props: {
    headline: {
      type: String,
      default: '',
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    counterTime: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    reco_name: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    reco_audience: {
      type: String,
      default: '',
    },
    freeText: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    timeLeft: '',
  }),
  mounted() {
    this.countDown();
  },
  methods: {
    countDown() {
      const countDownDate = new Date(this.counterTime).getTime();
      const timer = setInterval(() => {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        let daysLeft = '';
        if (days > 0) {
          daysLeft = `${days}d `;
        }

        this.timeLeft = `${daysLeft}${hours}h ${minutes}m ${seconds}s `;

        if (distance <= 1) {
          clearInterval(timer);
          this.timeLeft = null;
        }
      }, 1000);
    },
  },
});
</script>
